/*
 * Update the content on the page via an AJAX call.
 *
 * If the pages has been set to members only then the Construkt content will
 * be inserted into the DOM if the user is deemed to have the correct access.
 * Access is calculated by a call to Tessitura to check the user's constituencies.
 * see: childtheme/helpers/memberships.php
 *
 * Shared Sessiions is being used to determine the user's login state. If the
 * user is logged in then the below code also changes the first item in the
 * main navigation from "Log in" to "Account". The icon on the menu is also
 * changed at the same time.
 */
jQuery(function ($) {

    // Early return if shared sessions is not available
    if ($.fn.sharedSession === undefined) {
        console.error("Shared sessions plugin not loaded");
        return;
    }

    // Does the page require a valid membership to view the content.
    const membershipRequired = document.querySelector('body[data-membership="required"]');

    /**
     * Update the content section with the HTML provided.
     * This could be the members content from Construkt or it could be the
     * message telling the user that this content is for members only.
     *
     * @param {string} html
     * @returns {bool}
     */
    function updateContent(html) {
        const content = document.querySelector("#members-only-content");

        if (content) {
            content.innerHTML = html;
            window.setupTransitions();
            return true;
        }
        return false;
    }

    /**
     * Update the menu item with the log in status of the current user.
     * The values are taken from data-attribute on the HTML tags it is trying
     * to change.
     *
     * @param {int} userId
     * @returns {bool}
     */
    function updateMenuAccountAnchor(userId) {
        const icon = document.querySelector("[data-js_account_icon]");
        const text = document.querySelector("[data-js_account_text]");
        const link = document.querySelector("[data-js_account_link]");

        if (icon && text && link) {
            icon.classList = icon.dataset.js_account_icon;
            text.innerHTML = text.dataset.js_account_text;
            link.href = link.dataset.js_account_link;
            return true;
        }
        console.error("Could not select account menu item to change log in status");
        return false;
    }

    const requestConfig = {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': wpApiSettings.nonce
        },
        credentials: 'include'
    }

    /*
     * If the page is members only make a fetch request to the server to retrieve
     * the content that the user should be shown. Update the menu item too.
     */
    if (membershipRequired && window.memberships.post) {
        const endpoint = `${wpApiSettings.root}v1/members/access/?post=${window.memberships.post}`;
        const request = new Request(endpoint, requestConfig);

        fetch(request)
            .then(response => response.json())
            .then(data => {
                if (data.success && data.success === false) {
                    console.warn("Could not update menu and content")
                    return;
                }
                if (data.userId && data.userId !== 0) {
                    updateMenuAccountAnchor(data.userId);
                }
                updateContent(data.html);
            })
            .catch(error => console.log(error));
    } else {
        const endpoint = `${wpApiSettings.root}v1/members/login-status/`;
        const request = new Request(endpoint, requestConfig);

        // The page is not members only so only update the log in status
        fetch(request)
            .then(response => response.json())
            .then(data => {
                if (data.success && data.success === false) {
                    console.warn("Could not update menu");
                    return;
                }
                if (data.userId && data.userId !== 0) {
                    updateMenuAccountAnchor(data.userId);
                }
            })
            .catch(error => console.error(error));
    }
});




// WEBPACK FOOTER //
// ./src/js/memberships.js